import React, { Component } from "react";

class About extends Component{
    render(){
        let title = 'Chi Siamo',
        description = 'Da oltre 7 anni, BeatData cresce costantemente nella System Integration, costruendo rapporti di fiducia e partnership strategiche con aziende leader del settore. Le nostre soluzioni innovative, progettate su misura, rispondono alle esigenze dei clienti, garantendo crescita sostenibile e vantaggio competitivo.';
        return(
            <React.Fragment>
                <div className="about-wrapper">
                    <div className="container">
                        <div className="row row--35 align-items-center">

                            <div className="col-lg-5 col-md-12">
                                <div className="thumbnail">
                                    <img className="w-100" src="/assets/images/about/about-1.jpg" alt="About Images"/>
                                </div>
                            </div>

                            <div className="col-lg-7 col-md-12">
                                <div className="about-inner inner">
                                    <div className="section-title">
                                        <h2 className="title">{title}</h2>
                                        <p className="description">{description}</p>
                                    </div>
                                    <div className="row mt--30 mt_sm--10">
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="about-us-list">
                                                <h3 className="title">La Nostra Storia</h3>
                                                <p>La nostra missione è fornire soluzioni integrate di alto livello e un servizio clienti eccellente. La nostra storia di successo è fondata sulla passione per l'innovazione e l'impegno per l'eccellenza.</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="about-us-list">
                                                <h3 className="title">Il Nostro Team</h3>
                                                <p>Il nostro team è composto da esperti in sviluppo software, intelligenza artificiale, blockchain, IoT e IT Service Management. Collaboriamo per offrire soluzioni tecnicamente avanzate e su misura per i nostri clienti.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default About;